<!-- reports.component.html -->

<div class="rp">

  <!-- ── Page Header ─────────────────────────────── -->
  <div class="rp__header">
    <div>
      <h1 class="rp__title">Reports</h1>
      <p class="rp__subtitle">Filter, analyse and export field activity data.</p>
    </div>
    <div class="rp__header-actions">
      <button class="rp__export-btn rp__export-btn--pdf"
              (click)="exportPdf()"
              [disabled]="filteredLogs.length === 0 || exporting">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        Export PDF
      </button>
      <button class="rp__export-btn rp__export-btn--excel"
              (click)="exportExcel()"
              [disabled]="filteredLogs.length === 0 || exporting">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/>
          <line x1="3" y1="9"  x2="21" y2="9"  stroke="currentColor" stroke-width="1.8"/>
          <line x1="3" y1="15" x2="21" y2="15" stroke="currentColor" stroke-width="1.8"/>
          <line x1="9" y1="3"  x2="9"  y2="21" stroke="currentColor" stroke-width="1.8"/>
        </svg>
        Export Excel
      </button>
    </div>
  </div>

  <!-- ── Filter Card ──────────────────────────────── -->
  <div class="rp__filter-card">

    <div class="rp__filter-head">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                 stroke="currentColor" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="rp__filter-title">Filter Report</span>
      <button class="rp__reset-btn"
              (click)="resetFilters()"
              [disabled]="!hasActiveFilters">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <path d="M3 12C3 7 7.03 3 12 3C15.69 3 18.88 5.06 20.5 8"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <path d="M21 12C21 17 16.97 21 12 21C8.31 21 5.12 18.94 3.5 16"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <polyline points="20.5 3 20.5 8 15.5 8" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Reset
      </button>
    </div>

    <div class="rp__filter-grid">

      <!-- Date From -->
      <div class="rp__filter-field">
        <label class="rp__filter-label">From Date</label>
        <div class="rp__input-wrap">
          <svg class="rp__input-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/>
            <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="8"  y1="2" x2="8"  y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="3"  y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="1.8"/>
          </svg>
          <input class="rp__input" type="date"
                 [(ngModel)]="filters.dateFrom"
                 (change)="applyFilters()"/>
        </div>
      </div>

      <!-- Date To -->
      <div class="rp__filter-field">
        <label class="rp__filter-label">To Date</label>
        <div class="rp__input-wrap">
          <svg class="rp__input-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/>
            <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="8"  y1="2" x2="8"  y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="3"  y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="1.8"/>
          </svg>
          <input class="rp__input" type="date"
                 [(ngModel)]="filters.dateTo"
                 (change)="applyFilters()"/>
        </div>
      </div>

      <!-- Worker filter -->
      <div class="rp__filter-field">
        <label class="rp__filter-label">Worker</label>
        <div class="rp__input-wrap">
          <svg class="rp__input-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
            <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
          </svg>
          <select class="rp__select"
                  [(ngModel)]="filters.workerId"
                  (change)="applyFilters()">
            <option value="">All Workers</option>
            <option *ngFor="let w of workers" [value]="w.id">{{ w.fullName }}</option>
          </select>
        </div>
      </div>

      <!-- Job filter -->
      <div class="rp__filter-field">
        <label class="rp__filter-label">Job</label>
        <div class="rp__input-wrap">
          <svg class="rp__input-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
            <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
          <select class="rp__select"
                  [(ngModel)]="filters.jobId"
                  (change)="applyFilters()">
            <option value="">All Jobs</option>
            <option *ngFor="let j of jobs" [value]="j.id">{{ j.title }}</option>
          </select>
        </div>
      </div>

    </div>

    <!-- Quick range buttons -->
    <div class="rp__quick-ranges">
      <span class="rp__quick-label">Quick select:</span>
      <button class="rp__range-btn"
              [class.rp__range-btn--active]="activeRange === 'today'"
              (click)="setRange('today')">Today</button>
      <button class="rp__range-btn"
              [class.rp__range-btn--active]="activeRange === 'week'"
              (click)="setRange('week')">This Week</button>
      <button class="rp__range-btn"
              [class.rp__range-btn--active]="activeRange === 'month'"
              (click)="setRange('month')">This Month</button>
      <button class="rp__range-btn"
              [class.rp__range-btn--active]="activeRange === 'quarter'"
              (click)="setRange('quarter')">This Quarter</button>
    </div>

  </div>

  <!-- ── Loading ──────────────────────────────────── -->
  <div class="rp__loading" *ngIf="loading">
    <div class="rp__spinner"></div>
    <span>Loading report data…</span>
  </div>

  <!-- ── Summary Cards ────────────────────────────── -->
  <div class="rp__summary" *ngIf="!loading">
    <div class="rp__stat-card">
      <div class="rp__stat-icon rp__stat-icon--navy">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                stroke="currentColor" stroke-width="1.8"/>
        </svg>
      </div>
      <div class="rp__stat-body">
        <span class="rp__stat-val">{{ filteredLogs.length }}</span>
        <span class="rp__stat-label">Total Logs</span>
      </div>
    </div>

    <div class="rp__stat-card">
      <div class="rp__stat-icon rp__stat-icon--teal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <polyline points="12 6 12 12 16 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="rp__stat-body">
        <span class="rp__stat-val">{{ totalHours }}h</span>
        <span class="rp__stat-label">Hours Logged</span>
      </div>
    </div>

    <div class="rp__stat-card">
      <div class="rp__stat-icon rp__stat-icon--success">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
          <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
        </svg>
      </div>
      <div class="rp__stat-body">
        <span class="rp__stat-val">{{ activeWorkerCount }}</span>
        <span class="rp__stat-label">Active Workers</span>
      </div>
    </div>

    <div class="rp__stat-card">
      <div class="rp__stat-icon rp__stat-icon--warning">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
          <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="rp__stat-body">
        <span class="rp__stat-val">{{ activeJobCount }}</span>
        <span class="rp__stat-label">Jobs Covered</span>
      </div>
    </div>

    <div class="rp__stat-card">
      <div class="rp__stat-icon rp__stat-icon--info">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"
                    stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="rp__stat-body">
        <span class="rp__stat-val">{{ avgHoursPerLog }}h</span>
        <span class="rp__stat-label">Avg Hours / Log</span>
      </div>
    </div>

  </div>

  <!-- ── Results Table ─────────────────────────────── -->
  <div class="rp__table-card" *ngIf="!loading">

    <div class="rp__table-head">
      <div class="rp__table-head-left">
        <h3 class="rp__table-title">Activity Log</h3>
        <span class="rp__result-count">{{ filteredLogs.length }} result{{ filteredLogs.length !== 1 ? 's' : '' }}</span>
      </div>
      <div class="rp__search-wrap">
        <svg class="rp__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8"/>
          <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input class="rp__search"
               type="text"
               placeholder="Search logs…"
               [(ngModel)]="searchQuery"
               (input)="onSearch()"/>
      </div>
    </div>

    <!-- Empty state -->
    <div class="rp__empty" *ngIf="pagedLogs.length === 0">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
              stroke="currentColor" stroke-width="1.4"/>
        <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
      <p>No activity found for the selected filters.</p>
      <button class="rp__empty-reset" (click)="resetFilters()">Clear filters</button>
    </div>

    <!-- Table -->
    <div class="rp__table-wrap" *ngIf="pagedLogs.length > 0">
      <table class="rp__table">
        <thead>
          <tr>
            <th class="rp__th" (click)="sortBy('worker')">
              Worker
              <span class="rp__sort-icon" [class.rp__sort-icon--active]="sortField === 'worker'">↕</span>
            </th>
            <th class="rp__th" (click)="sortBy('job')">
              Job
              <span class="rp__sort-icon" [class.rp__sort-icon--active]="sortField === 'job'">↕</span>
            </th>
            <th class="rp__th">Notes</th>
            <th class="rp__th rp__th--center" (click)="sortBy('hours')">
              Hours
              <span class="rp__sort-icon" [class.rp__sort-icon--active]="sortField === 'hours'">↕</span>
            </th>
            <th class="rp__th" (click)="sortBy('date')">
              Date
              <span class="rp__sort-icon" [class.rp__sort-icon--active]="sortField === 'date'">↕</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="rp__row" *ngFor="let log of pagedLogs">

            <!-- Worker -->
            <td class="rp__td">
              <div class="rp__worker-cell">
                <div class="rp__avatar" [style.background]="getAvatarColor(log.userId)">
                  {{ getInitials(getWorkerName(log.userId)) }}
                </div>
                <span class="rp__worker-name">{{ getWorkerName(log.userId) }}</span>
              </div>
            </td>

            <!-- Job -->
            <td class="rp__td">
              <span class="rp__job-name">{{ getJobTitle(log.jobId) }}</span>
            </td>

            <!-- Notes -->
            <td class="rp__td rp__td--muted">
              {{ log.notes || '—' }}
            </td>

            <!-- Hours -->
            <td class="rp__td rp__td--center">
              <span class="rp__hours-pill">{{ log.hoursSpent }}h</span>
            </td>

            <!-- Date -->
            <td class="rp__td rp__td--muted rp__td--nowrap">
              {{ log.createdUtc | date:'MMM d, y, h:mm a' }}
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="rp__pagination">
        <span class="rp__pagination-info">
          Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, filteredLogs.length) }}
          of {{ filteredLogs.length }}
        </span>
        <div class="rp__pagination-controls">
          <button class="rp__page-btn"
                  (click)="goToPage(currentPage - 1)"
                  [disabled]="currentPage === 1">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="rp__page-btn rp__page-btn--num"
                  *ngFor="let p of pageNumbers"
                  [class.rp__page-btn--active]="p === currentPage"
                  (click)="goToPage(p)">
            {{ p }}
          </button>
          <button class="rp__page-btn"
                  (click)="goToPage(currentPage + 1)"
                  [disabled]="currentPage === totalPages">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>